/** Agency CRM screens (flag crm.partner_crm): thin wrappers around the shared features/agency-crm workspace. */
import { useState } from 'react';
import { AgencyCrm, type CrmSection } from '../../../features/agency-crm/AgencyCrm';
import { useSurface } from '../kit/context';
import { Screen } from '../kit/ui';

export function CrmScreen({ section }: { section: CrmSection }) {
  const { t, locale, http, preload } = useSurface();
  // The primary action ("+ New deal") sits at the end of the page header row, beside the title.
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <Screen title={t(`crm.agency.title.${section}`)} subtitle={t('crm.agency.subtitle')} testId={`partner-crm-${section}`} actions={<div ref={setSlot} className="ac-head-slot" />}>
      <AgencyCrm http={http} t={t} locale={locale} section={section} base="/crm" preload={{ [section]: preload[`crm:${section}`] }} actionSlot={slot} />
    </Screen>
  );
}

export const CrmPipelinePage = () => <CrmScreen section="pipeline" />;
export const CrmLeadsPage = () => <CrmScreen section="leads" />;
export const CrmContactsPage = () => <CrmScreen section="contacts" />;
export const CrmCompaniesPage = () => <CrmScreen section="companies" />;
export const CrmTasksPage = () => <CrmScreen section="tasks" />;
export const CrmActivitiesPage = () => <CrmScreen section="activities" />;
export const CrmImportPage = () => <CrmScreen section="import" />;
